import { render, staticRenderFns } from "./RuleList.vue?vue&type=template&id=35713fcb&scoped=true"
import script from "./RuleList.vue?vue&type=script&lang=js"
export * from "./RuleList.vue?vue&type=script&lang=js"
import style0 from "./RuleList.vue?vue&type=style&index=0&id=35713fcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35713fcb",
  null
  
)

export default component.exports